import { connect } from 'react-redux';
import { IRootState } from 'redux/reducer';
import { selectRouteResource } from 'redux/routing/selectors';
import { rrc } from 'utils/strings/resourceClasses';

import { HourlyResultsMulti as Component } from './HourlyResultsMulti.component';

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = typeof mapDispatchToProps;

type IInjectedProps = IStateProps & IDispatchProps;

export type IProps = IInjectedProps;

const mapStateToProps = (rootState: IRootState) => {
  return {
    routeMultiSimulationGroup: selectRouteResource(rrc.multi_simulation_group)(rootState),
  };
};

const mapDispatchToProps = {};

export const HourlyResultsMulti = connect(mapStateToProps, mapDispatchToProps)(Component);
